<template>
  <div class="rounded bg-white p-5">
    <XHeader />

    <div>
      <span class="block mb-10 text-xl text-grey-30 font-medium text-center">
        {{ $t('common.confirmInvitation.sections.success.title', { name: userName }) }}
      </span>
      <div class="text-center mb-8">
        <XButton
          type="link"
          :to="loginUrl"
          color="secondary">
          {{ $t('common.confirmInvitation.sections.success.action') }}
        </XButton>
      </div>
    </div>
  </div>
</template>

<script>
import XHeader from './common/Header'
import store from '@plat/store'

export default {
  data () {
    return {
      loginUrl: store.state.config.app.baseUrl + '/login'
    }
  },

  components: {
    XHeader
  },

  props: {
    userName: {
      type: String,
      required: true
    }
  }
}
</script>
